<section class="login-shell">
  <div class="login-shell__frame">
    <header class="login-shell__bar">
      <div class="login-shell__brand">
        <div class="login-shell__mark login-shell__mark--bar" aria-hidden="true">
          <img
            *ngIf="config().logoUrl; else fallbackBarMark"
            [src]="config().logoUrl"
            [alt]="config().logoAlt || config().applicationName"
          />
          <ng-template #fallbackBarMark>{{ brandMark() }}</ng-template>
        </div>

        <div class="login-shell__brand-copy">
          <p class="login-shell__brand-name">{{ config().applicationName }}</p>
          <p *ngIf="config().subtitle" class="login-shell__brand-subtitle">{{ config().subtitle }}</p>
        </div>
      </div>

      <p class="login-shell__bar-title">
        {{ isAssuranceChallenge() ? 'Confirm your identity' : isInternalPasswordProvider() ? 'Sign in' : config().headerLabel }}
      </p>
    </header>

    <div class="login-shell__content">
      <article class="login-card">
        <div class="login-card__badge" aria-hidden="true">
          <div class="login-shell__mark login-shell__mark--card">
            <img
              *ngIf="config().logoUrl; else fallbackCardMark"
              [src]="config().logoUrl"
              [alt]="config().logoAlt || config().applicationName"
            />
            <ng-template #fallbackCardMark>{{ brandMark() }}</ng-template>
          </div>
        </div>

        <div class="login-card__body">
          <div class="login-card__copy">
            <h1>{{ config().applicationName }}</h1>
            <p class="login-card__subtitle">
              <ng-container *ngIf="isInternalPasswordProvider(); else providerHeading">
                {{ config().headerLabel }}
              </ng-container>
              <ng-template #providerHeading>
                Use the supported provider challenge to continue.
              </ng-template>
            </p>
          </div>

          <div *ngIf="failureMessage()" class="login-card__message" role="alert">
            {{ failureMessage() }}
          </div>

          <ng-container *ngIf="isInternalPasswordProvider(); else providerLaunch">
            <ui-form
              class="login-form"
              [config]="loginFormConfig"
              [theFormGroup]="loginForm"
              [enabled]="loginAvailable() && !isSubmitting()"
              [showInlineErrors]="true"
              [showFormErrors]="false"
              (keydown.enter)="onInternalFormEnter($event)"
            ></ui-form>

            <a
              *ngIf="config().showHelpLink && config().helpLinkUrl"
              class="login-card__help login-card__help--internal"
              [href]="config().helpLinkUrl"
              target="_blank"
              rel="noreferrer"
            >
              {{ helpLinkText() }}
            </a>

            <ui-button
              class="login-card__cta"
              [buttonText]="isSubmitting() ? 'Signing in...' : config().signInButtonText"
              [disabled]="!loginAvailable() || isSubmitting()"
              (click)="submit()"
            ></ui-button>
          </ng-container>

          <ng-template #providerLaunch>
            <ui-button
              class="login-card__cta"
              [buttonText]="config().signInButtonText"
              [disabled]="!loginAvailable() || isSubmitting()"
              (click)="submit()"
            ></ui-button>
          </ng-template>

          <p *ngIf="!loginAvailable()" class="login-card__support">
            Sign-in is not available in the current environment configuration.
          </p>

          <a
            *ngIf="!isInternalPasswordProvider() && config().showHelpLink && config().helpLinkUrl"
            class="login-card__help"
            [href]="config().helpLinkUrl"
            target="_blank"
            rel="noreferrer"
          >
            {{ helpLinkText() }}
          </a>
        </div>

        <footer class="login-card__footer">
          {{ config().footerNotice }}
        </footer>
      </article>
    </div>
  </div>
</section>
